import { IState } from '../../index';

export const selectOfferValuationData = (state: IState) => state.offerValuation.data;

export const selectEstimationPeriod = (state: IState) => state.offerValuation.estimationPeriod;

export const selectIsAdmin = (state: IState) => state.offerValuation.isAdmin;
